export default __webpack_public_path__ + "static/media/error_found.636dcf2c.svg";